import React, { useState, useEffect, useContext } from "react";
import { Slider } from "antd";
import AHPSelect from "../../components/AHPSelect/AHPSelect";
import { AppContext } from "../../context";
import { searchGoods } from "./searchGoods";
import { GOODS } from "./goodsConstants";
import { FIELD_WIDTHS } from "../../config/layoutConfig";

const getCategoryOptions = (roles, t) => {
  // goods category options
  let options = GOODS.CATEGORIES.map((c) => ({
    value: c,
    label: t(c),
  }));

  // goods categories available for specific roles
  if (roles?.includes("coworker"))
    options = [
      ...options,
      {
        label: "Material de escritório",
        value: "office-supplies",
      },
    ];
  return options;
};

function GoodsFilter({ setProducts, store }) {
  const [goodsCategories, setGoodsCategories] = useState([]);
  const [category, setCategory] = useState("");
  const [minPrice, setMinPrice] = useState(null);
  const [maxPrice, setMaxPrice] = useState(null);
  const info = useContext(AppContext);

  // initialize filter
  useEffect(() => {
    setGoodsCategories(getCategoryOptions(info.user?.roles, info.t));
    // minimum and maximum price
    setMinPrice(GOODS.PRICE_RANGE[0]);
    setMaxPrice(GOODS.PRICE_RANGE[1]);
  }, []);

  useEffect(() => {
    (async () => {
      const store_id = null;
      const goods = await searchGoods(store_id, info);
      setProducts(goods);
    })();
  }, [info.goods, info.villages]);

  const handleSliderChange = (value) => {
    setMinPrice(value[0]);
    setMaxPrice(value[1]);
    info.setGoods({ ...info.goods, minPrice: value[0], maxPrice: value[1] });
  };

  return (
    <div style={{ display: "flex", marginTop: 10 }}>
      <AHPSelect
        label={info.t("category")}
        type="goods"
        field="category"
        options={goodsCategories}
        allowClear
      />

      <div style={{ marginTop: 5, marginRight: 15 }}>
        {info.t("price")}: {minPrice} € - {maxPrice} €
      </div>

      {minPrice != null && maxPrice != null && (
        <Slider
          range
          defaultValue={[GOODS.PRICE_RANGE[0], GOODS.PRICE_RANGE[1]]}
          style={{ width: FIELD_WIDTHS.M }}
          max={GOODS.PRICE_RANGE[1]}
          onAfterChange={handleSliderChange}
        />
      )}
    </div>
  );
}

export default GoodsFilter;
